import React from 'react';
import { useViewModule } from 'hook/helper.hook';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { useSeenModulePixel } from 'hook/helper.hook';
import { PlPrequalOfferModuleView } from './PlPrequalOfferModuleView';
import { useEventHandler } from 'hook/event.hook';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import { PL_PREQUAL_OFFER_MODULE } from 'types/morph.pagePosition.constants';
import { PERSONAL_LOAN_VERTICAL } from 'types/marketplaceTiles.constants';
import { redirectPersonalLoanOfferWithStaticModule } from 'actions/offers.actions';

const PlPrequalOfferModuleController = ({
  moduleList,
  modulePosition,
  dispatch,
  ...props
}) => {
  const moduleData = moduleList.modules[modulePosition - 1];
  const eventHandler = useEventHandler();

  function onClickSeeMoreOffers() {
    eventHandler(CLICK, {
      'Click Type': 'See more pre-qualified offers',
      'Page Position': PL_PREQUAL_OFFER_MODULE,
      Vertical: PERSONAL_LOAN_VERTICAL,
    });
    dispatch(
      redirectPersonalLoanOfferWithStaticModule(
        props.history,
        'PERSONAL_LOAN_PREQUAL_RESULTS',
      ),
    );
  }

  const atr = getViewModuleTrackingAttributes({
    pagePosition: PL_PREQUAL_OFFER_MODULE,
    modulePosition: modulePosition,
    vertical: 'Personal Loan',
  });
  const seenPixel = useSeenModulePixel(atr);

  useViewModule(atr, !moduleData.isActionsModule);

  return (
    <PlPrequalOfferModuleView
      onClickSeeMoreOffers={onClickSeeMoreOffers}
      pagePosition={PL_PREQUAL_OFFER_MODULE}
      modulePosition={modulePosition}
      seenPixel={seenPixel}
      {...moduleData}
      {...props}
    />
  );
};

export { PlPrequalOfferModuleController };
